import axios from 'axios';
import store from '../store';

const PREFIJO="/api/Prpt/";

export default {
    informacion() {
        const dto={id:store.getters.getUsuario.ndt1};
        return axios.post(`${PREFIJO}VmIdPrp`,dto);
    },
    actualizar(formulario) {
        const dto =
            {
                id:store.getters.getUsuario.ndt1,
                dt2:formulario.nombres,
                dt3:formulario.apellidos,
                dt5:formulario.email,
                dt6:formulario.telefono,
                ndt4:formulario.tipoEmail.id,
                ndt5:formulario.tipoTelf.id,
                ndt7:store.getters.getUsuario.id,
                elements: [
                    {
                        dt1: formulario.calle1,//"CallePrincipal",
                        dt2: formulario.calle2,//"CalleSecundaria",
                        dt3: formulario.numero,//"NumeroCalle",
                        dt4: formulario.referencia,//"ReferenciaDireccion",
                        dt5: formulario.barrio,//"Barrio",
                        // dt10: formulario.tipoCanton.id,//"Canton",
                        // dt11: formulario.tipoParro.id,//"Parroquia",
                        bdt1: true,//"DireccionDefault",
                        ndt1: formulario.tipoDir.id,//"TipoDireccionId",
                        ndt2: formulario.tipoCanton.id,//"CantonId",
                        ndt3: formulario.tipoParro.id,//"ParroquiaId"
                    }
                ]

            };
        return axios.post(`${PREFIJO}VmUpPrp`,dto);
    }
};
